<template>
      <div style="width:1300px;margin:0 auto;font-size:13px;">
           <div v-if="showPage" class="card mb-5 p-2" style="box-shadow: 10px 10px 5px #888888;margin-top:30px;">
                <p class="text-center mb-2">
                     <span style="font-size:15px;">
                       论坛
                     </span>
                      <span class="float-right span_close" style="display:block;width:20px;line-height:20px;text-align:center;font-size:25px;" @click="$router.go(-1)">
                           &times;
                      </span>
                </p>
                <div class="mb-1" style="position:relative;">
                      <ol class="breadcrumb">
                         <li><a href="#" :class="{active:show==2}" @click.prevent="getAllLog(2)">全部发布</a></li>
                         <li><a href="#" :class="{active:show==1}" @click.prevent="getMyLog(1)">我的发布</a></li>
                     </ol>
               </div>
               <div style="position:absolute;top:41px;right:42px;" class="mb-1">
                    <!-- <button class="btn btn-primary" :class="{active_kan:kanlog==0}" @click="getBlog(1,0)">
                         未审阅的论坛
                    </button>
                    <button class="btn btn-info" :class="{active_kan:kanlog==1}" @click="getBlog(1,1)">
                         已审阅的论坛
                    </button> -->
                    <!-- <button class="btn btn-info" @click="getBlog(2)">
                          驳回的日志
                    </button> -->
                    <!-- <button class="btn btn-danger" @click="getBlog(3)">
                          已删除的日志
                    </button> -->
                     <button class="btn btn-primary" @click="addLog()">发布帖子</button>
               </div>
                 <div v-show="BlogList.length>0">


                    <!-- <table class="table table-striped table-hover" ref="print">
                        <thead>
                                <tr style="white-space: nowrap;">
                                     <th class="text-center">标题</th>
                                     <th class="text-center">时间</th>
                                     <th class="text-center">作者</th>
                                     <th class="text-center">回复条数</th>
                                     <th class="text-center">操作</th>
                               </tr>
                        </thead>
                        <tbody>
                                 <tr v-for="(item,index) in BlogList" :key="index">
                                                            <td class="text-center jz_middle" style="color:green">
                                                                 <p class="toTop" v-if="item.topindex!==0">置顶
                                                                         <img class="img_top" src="../../../static/images/weiba.png" alt="" style="widht:30px;height:30px;">
                                                                 </p>
                                                               
                                                                {{item.title}}
                                                            </td>
                                                            <td class="text-center jz_middle">{{item.inserttime.substring(0,10)}}</td>
                                                            <td class="text-center jz_middle" style="color:#f4930a">{{item.truename}}</td>
                                                            <td class="text-center jz_middle" style="color:red;font-weight:700;">{{item.cot}}</td>
                                                            <td v-if="item.username==username" class="text-center jz_middle">
                                                                <div>
                                                                   <div v-if="showInformation(item.inserttime)">
                                                                      <button class="btn btn-primary" @click="goLog(item.id)">查看</button>
                                                                      
                                                                      <button v-if="showxiu" class="btn btn-info" @click="change(item.id)">修改</button>
                                                                      
                                                                      <button v-if="showxiu" class="btn btn-danger" @click="modificationBlog(item.id)">删除</button>
                                                                   </div>
                                                                <div v-if="showInformation1(item.inserttime)">
                                                                       <button class="btn btn-primary" @click="goLog(item.id)">查看</button>
                                                                </div>
                                                                </div>
                                                            </td>

                                                            <td v-if="item.username!=username" class="text-center jz_middle">
                                                                 <button class="btn btn-primary" @click="goLog(item.id)">查看</button>
                                                                 
                                                            </td>
                                                            
                                 </tr>
                        </tbody>
                </table> -->

                          <li class="luntan_c" v-for="(item,index) in BlogList" :key="index" @click="goLog(item.id)">
                                 <div class="luntan_c-left">
                                     <span class="threadlist_rep_num" title="回复">{{item.cot | cot}}</span>
                                 </div>
                                 <div class="luntan_c-right">
                                      <div class="clearfix">
                                            <div class="threadlist_title">
                                                  <img v-if="item.topindex!==0" src="../../../static/images/top.png" style="margin-bottom:5px;" alt="">
                                                  <a class="luntan_a" href="javascript:;" @click="goLog(item.id)">
                                                            {{item.title}}
                                                  </a>
                                               
                                            </div>
                                            <div class="threadlist_author pull_right">
                                                 <!-- <i class="icon_author">  </i> -->
                                                 <img src="../../../static/images/icon_author.png" alt="">
                                                 <span class="frs-author-name-wrap">
                                                    {{item.truename}}
                                                 </span>
                                            </div>
                                          
                                      </div>
                                      <div>
                                          <div class="contents_c threadlist_abs" v-html="item.contents">
                                               
                                          </div>
                                          <div>
                                                 <div class="image_content">
                                                                      
                                                                                <img v-if="item.image1!==''" class="Image mr-1 limg"
                                                                                     :src="'http://fw.hyey.cn'+item.image1"
                                                                                     alt=""
                                                                                >
                                                                                
                                                                                <img v-if="item.image2!==''" class="Image mr-1 limg"
                                                                                     :src="'http://fw.hyey.cn'+item.image2"
                                                                                     alt=""
                                                                                >
                                                                                
                                                                                <img v-if="item.image3!==''" class="Image mr-1 limg"
                                                                                     :src="'http://fw.hyey.cn'+item.image3"
                                                                                     alt=""
                                                                                >
                                                                                
                                                                                <img v-if="item.image4!==''" class="Image mr-1 limg"
                                                                                     :src="'http://fw.hyey.cn'+item.image4"
                                                                                     alt=""
                                                                                >
                                                                                
                                                                                <img v-if="item.image5!==''" class="Image mr-1 limg"
                                                                                     :src="'http://fw.hyey.cn'+item.image5"
                                                                                     alt=""
                                                                                >
                                                                  
                                                        </div>
                                          </div>
                                      </div>
                                      <div v-if="item.username==username">
                                             <div id="green_channel" class="xiu_c" style="text-align:right;" v-if="showInformation(item.inserttime)">
                                                       <a id="green_channel_digg" v-if="showxiu" class="xiugai_btn" @click="change(item.id)">修改</a>
                                                                      
                                                       <a id="green_channel_follow" v-if="showxiu" class="shanchun_btn" @click="modificationBlog(item.id)">删除</a>
                                            </div>
                                      </div>
                                     
                                          
                                       <p style="text-align:right;color:#999;">{{item.inserttime.substring(0,10)}}</p>
                                 </div>
                               
                          </li>



                         <div style="border-top:1px dashed #ccc;padding-top:15px;">
                              <v-pagination :total="total" :current-page='current' @pagechange="pagechange"></v-pagination>
                         </div>
                </div>
                <div v-show="record===0" class="text-center">
                     <img src="../../../static/images/timg.jpg" alt="">
                </div>
                <!-- <p class="text-center">
                        <button class="btn btn-primary" @click="addLog()" >添加日志</button>
                </p> -->
           </div>
      </div>
</template>

<script>
import vPagination from "../../components/Pagination.vue";
export default {
      data(){
          return{
              BlogList:[],
              lxs:2,
              state:'',
              pageIndex:'',
              username:'',
              contents:'',
              id:'',
              title:'',
              reply:'',
              record:'',
              show:2,
              shang:true,
              others:false,
              showxiu:false,
              kanlog:'',
              showPage:false,
              lx:"",
              key:"",
          
              
            total:1,     // 记录总条数
            display: 20,   // 每页显示条数
            current: 1,   // 当前的页数

          }
      },
      components:{
           vPagination,
      },
    filters: {
      getState:function(result) {
            switch(result){
               case 0:
               return "未审阅";
               case 1:
               return "已审阅";
               case 2:
               return "已驳回";
               case 3:
               return "已删除";
            }
        } ,
        gongShi:function(gongShi){
           if(gongShi==1){
                return '已公示'
           }
          //  else{
          //       return '未公示'
          //  }
     },
        changeTitle:function(title){
                  if(title==null){
                       return title
                  }
                  else{
                       return title.substring(22);
                  }
        },
        cot:function(cot){
             if(cot==null){
                  return 0
             }
             else{
                  return cot
             }
        },
   },
      methods:{
           //展示信息
           showInformation(item){
                if(item.replace(/\-/g, "")<this.getDay1(0)){
                    return false;
                }
                else{
                     return true;
                }
           },
             showInformation1(item){
                if(item.replace(/\-/g, "")<this.getDay1(0)){
                    return true;
                }
                else{
                     return false;
                }
           },
            getDay1(day) {　　
                var today = new Date();　　
                var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;　　
                today.setTime(targetday_milliseconds); //注意，这行是关键代码
                　　
                var tYear = today.getFullYear();　　
                var tMonth = today.getMonth();　　
                var tDate = today.getDate();　　
                tMonth = this.doHandleMonth(tMonth + 1);　　
                tDate = this.doHandleMonth(tDate);　　
               return tYear + "" + tMonth + "" + tDate;
            },
            doHandleMonth(month) {　　
                var m = month;　　
                if (month.toString().length == 1) {　　
                    m = "0" + month;　　
                }　　
               
                return m;
                
            },


              pagechange:function(currentPage){
                 this.changeBlog(currentPage);
     },

           
           //分页日志
           changeBlog(currentPage){
               //  console.log(currentPage);
                const that=this;
                that.state=that.state;
                this.getBlog(currentPage,that.state);

           },
           //查看别人日志时不能修改
           stopChange(){
              this.username = window.sessionStorage.getItem('username');
                
           },
          //获取日志
        getBlog: async function (pageIndex,state,key) {
             this.state=state;
             if(state===3){this.shang=false}
             else{
                  this.shang=true
                  
             }
          //    if(state===1){
          //         this.showxiu=false;
          //         this.kanlog=1;
          //    }
          //    else{
          //         this.showxiu=true;
               
          //         this.kanlog=0;
          //    }
        const { data: res } = await this.$http.post('Dls/getFun', {
          action: 'ClerkGetBlog',
          obj: JSON.stringify({
               lxs:4,
               state:0,
               lx:4,
               pageIndex,
               key:key,
          })
        })
     //     console.log(res)
        if (res.isok) {
             if(res.data.isok){
                  const obj = res.data
                  this.showPage=true
                  this.record = obj.record
                  this.BlogList = obj.rows
                  this.total = obj.totalCount
                    if(state===1){
                  this.showxiu=false;
                  this.kanlog=1;
                      }
                    else{
                         this.showxiu=true;
                         
                         this.kanlog=0;
                    }
     
             }
             else{
                  alert(res.data.msg);
             }
        }
        else{
             alert(res.message);
        }
      },
      //我的日志
       getMyLog(lxs){
            this.lxs=lxs;
            this.show=1;
            this.key=this.username
            this.getBlog(1,0,this.key);
       },
       getAllLog(lxs){
            this.lxs=lxs;
            this.show=2;
            this.key=""
            this.getBlog(1,0,this.key);    
       },
       //删除日志
       modificationBlog:async function(id){
          const { data: res } = await this.$http.post('Dls/getFun', {
          action: 'ClerkUpBlog',
          obj: JSON.stringify({
               //  username:'kzy001',
                lxs:'4',
                state:'3',
               //  contents:'这是我实验的日志',
                id,
               //  title:'2020-04-27 10:16:24__我的日志',
               //  reply:'',
          })
        })
     //    console.log(res)
        if (res.isok) {
             if(res.data.isok){
               this.$message.success(res.data.msg)
                  this.getBlog(1,this.state)
                  const obj = res.data
             }
        }
       },
       //查看日志
       goLog(id){
            this.$router.push({path: '/lookForum', query:{id:id}})
       },
       //修改日志
       change(id,title,contents,truename){
            this.$router.push({path: '/changeForum', query:{id:id}})
       },
      //添加日志
       addLog(){
            this.$router.push({path: '/addForum'})
       }
      },
     //  beforeRouteEnter(to,from,next){
     //        console.log(to);
     //        console.log(from);
     //         console.log("进入日志列表")
     //         next();
     //  },
     //  beforeRouteLeave(to,from,next){
     //        console.log("离开日志列表")
     //        if(to.name=="lookLog"){
     //           from.meta.keepAlive=true;
     //        }
     //        next();
     //  },
      created(){
          this.stopChange();
          this.getBlog(1,0,this.key);
      }
}
</script>

<style lang="less" scoped>
.autocut{
     overflow:hidden;
      white-space:nowrap;
      text-overflow:ellipsis;
      -o-text-overflow:ellipsis;
     -khtml-text-overflow: ellipsis;
     -moz-text-overflow: ellipsis;
    -webkit-text-overflow: ellipsis;
}
.jz_middle{
   vertical-align:middle;
 }
 .span_close:hover{
       color:#3190e8;
 }
 .breadcrumb > li + li:before {
    color: #CCCCCC;
    content: "/ ";
    padding: 0 5px;
}
.active{
     color:#36d;
}
.active_kan{
     color:red;
}
.toTop {
    background:#36d;
    bottom: 0;
    cursor: pointer;
    height: 21px;
    right: 0;
    color:#fff;
    margin-left:10px;
    width: 42px;
    border-radius:5px;
    position: relative;
}
.img_top{
     position: absolute;
     top:-2px;
     left:11px;
}
.luntan_c{
     border-top:1px dashed #ccc;
     border-left:1px solid #ccc;
     border-right:1px solid #ccc;
     padding:10px;
}
.luntan_c:hover{
     background:#ecf2fc;
}
.luntan_a{
     color:#36d;
}
.luntan_a:hover{
     color:#36d;
     text-decoration: underline;
}
.threadlist_rep_num {
    display: inline-block;
    width: 50px;
    height: 30px;
    line-height: 26px;
    margin-right: 20px;
    text-align: center;
    background: url(../../../static/images/f_reply_bg.png) no-repeat;
}
.luntan_c-left{
     float:left;
}
.luntan_c-right{
     margin-left:70px;
}
.threadlist_title {
    font-size: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.threadlist_title{
     width:620px;
}
.threadlist_author {
    width: 165px;
    color: #999;
}

.pull_right, .pull-right {
    float: right!important;
}
.clearfix {
    zoom: 1;
}
.clearfix:after {
    content: "\20";
    display: block;
    height: 0;
    clear: both;
    overflow: hidden;
    visibility: hidden;
}
.icon_author {
   
    background: url(../../../static/images/icon_author.png) no-repeat 0px 0px; 
}
.threadlist_author .frs-author-name-wrap {
    display: inline-block;
    width: 87px;
}
.limg{
     width:100px;
     height:100px;
}
.contents_c{
     margin-bottom:30px;
}
.threadlist_abs {
    width: 620px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #666;
}
.xiu_c{
     margin-bottom:15px;
}
.image_content{
     margin-bottom:15px;
}
#green_channel #green_channel_digg {
    background-color: #2daebf;
}
#green_channel a:link, #green_channel a:visited, #green_channel a:active {
    color: #fff !important;
    border: none !important;
}
#green_channel a {
//     background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAAkCAYAAABIdFAMAAAAGXRFW…99ZOdcZGvt4mJjzMVKqcha68iIePB86GAiOv8CDADlIUQBs7MD3wAAAABJRU5ErkJggg%3D%3D) repeat-x;
    display: inline-block;
    padding: 3px 8px;
    color: #fff;
    text-decoration: none;
    font-weight: bold;
    cursor: pointer;
    margin-right: 10px;
    -moz-border-radius: 5px;
    -webkit-border-radius: 10px;
    -moz-box-shadow: 0 1px 3px rgba(0,0,0,.5);
    -webkit-box-shadow: 0 1px 3px rgba(0,0,0,.5);
    text-shadow: 0 -1px 1px rgba(0,0,0,.25);
    vertical-align: middle;
}
#green_channel #green_channel_follow {
    background-color: #e33100;
}

#green_channel a:link, #green_channel a:visited, #green_channel a:active {
    color: #fff !important;
    border: none !important;
}
#green_channel a {
//     background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAAkCAYAAABIdFAMAAAAGXRFW…99ZOdcZGvt4mJjzMVKqcha68iIePB86GAiOv8CDADlIUQBs7MD3wAAAABJRU5ErkJggg%3D%3D) repeat-x;
    display: inline-block;
    padding: 3px 8px;
    color: #fff;
    text-decoration: none;
    font-weight: bold;
    cursor: pointer;
    margin-right: 10px;
    -moz-border-radius: 5px;
    -webkit-border-radius: 10px;
    -moz-box-shadow: 0 1px 3px rgba(0,0,0,.5);
    -webkit-box-shadow: 0 1px 3px rgba(0,0,0,.5);
    text-shadow: 0 -1px 1px rgba(0,0,0,.25);
    vertical-align: middle;
}

</style>




// WEBPACK FOOTER //
// src/pages/Forum/forum.vue